import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import x from '../../../images/x-icon_black_blade.svg';
import img from '../../../images/icon_16px_internal.svg';
import { ButtonStyles } from '../../Core/Button/styles';

export const ModalButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  display: flex;
  align-items: center;
  width: 100%;
  line-height: 1.25rem;
  font-size: 1rem;
  font-weight: ${themeGet('fontWeights.normal')};

  &::after {
    content: '';
    height: 12px;
    width: 12px;
    background-image: url(${img});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-left: 0.5rem;
    transition: all 0.3s ease;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
    &::after {
      transform: translateX(4px);
      transition: all 0.3s ease;
    }
  }

  &.product-block {
    padding: 1rem 0;
    border-top: 1px solid ${themeGet('colors.cta-border-grey')};
    border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
    justify-content: space-between;
    margin-bottom: 3rem;
    font-size: 1.25rem;
  }

  &.no-chevron {
    &::after {
      display: none;
    }
  }

  &.link-secondary {
    &::after {
      content: '';
      height: 12px;
      width: 12px;
      background-image: url(${img});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-color: transparent;
      margin-left: 0.5rem;
      transition: all 0.3s ease;
    }
  }

  ${ButtonStyles}
`;

export const Wrapper = styled.div`
  position: relative;

  &.no-chevron {
    display: inline-block;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Overlay = styled.div`
  position: fixed;
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  pointer-events: all;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
`;

export const Modal = styled.div`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  max-width: 768px;
  width: 90%;
  min-width: 280px;
  border-radius: 0.75rem;
  background-color: ${themeGet('colors.white')};
  padding: 1.5rem;
  max-height: 90%;
  overflow-y: scroll;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 1.75rem;
  }
`;

export const CloseBtn = styled.button.attrs(() => ({
  type: 'button',
}))`
  font-size: 16px;
  letter-spacing: -0.06px;
  display: flex;
  align-items: center;
  color: transparent;
  z-index: 1;

  &::after {
    content: '';
    display: block;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url(${x});
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &::after {
      height: 1.5rem;
      width: 1.5rem;
    }
  }
`;

export const Disclaimer = styled.p`
  text-align: center;
  font-size: 1rem;
  line-height: 150%;
  margin-top: 3rem;
`;
